import React, { Fragment } from 'react';
import { string, number, bool } from 'prop-types';

import { Strong } from '../Text';
import { Metric } from '../../constants';
import { capitalize } from '../../utils/helpers';
import TimeRange from './TimeRange';

import {
  Compare as ICompare,
  Precision as IPrecision,
  Metric as IMetric,
} from '../../models';

const getCensusLabel = count =>
  count === 1 ? 'census tract' : 'census tracts';
const getCitiesLabel = count => (count === 1 ? 'US city' : 'US cities');

export const CrimeCount = ({
  censusView,
  crimeTypeText,
  locationsCount,
  metric,
  city,
  noCapitalization,
  ...rest
}) => (
  <span style={{ fontWeight: '300' }}>
    <Strong>
      {noCapitalization ? crimeTypeText : capitalize(crimeTypeText)}{' '}
    </Strong>
    {metric === Metric.RATE ? (
      <Fragment>
        <Strong>rate</Strong> per {censusView ? '1k' : '100k'}
      </Fragment>
    ) : (
      ''
    )}
    {' in '}
    <Strong>
      {locationsCount}{' '}
      {censusView
        ? getCensusLabel(locationsCount)
        : getCitiesLabel(locationsCount)}
    </Strong>
    {city ? (
      <React.Fragment>
        {' of '}
        <Strong>{city}</Strong>{' '}
      </React.Fragment>
    ) : (
      ''
    )}
    {' for '}
    <TimeRange {...rest} />
  </span>
);

CrimeCount.propTypes = {
  noCapitalization: bool,
  censusView: bool.isRequired,
  crimeTypeText: string.isRequired,
  locationsCount: number.isRequired,
  compare: ICompare.isRequired,
  precision: IPrecision.isRequired,
  metric: IMetric,
  compareInterval: string,
  timespanInterval: string,
  city: string,
};

export default CrimeCount;



// WEBPACK FOOTER //
// ./src/components/CrimeCount/CrimeCount.jsx